// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z42g","questions":"styles_questions__3MPNi","footer":"styles_footer__32gno"};